import PropTypes from 'prop-types';
import React from 'react';

import { SvgIcon } from '@mui/material';
import { isNil } from 'lodash';

const IconHamburgerMenu = ({ height, width }) => (
  <SvgIcon
    focusable="false"
    viewBox={!isNil(height) && !isNil(width) ? `0 0 ${width} ${height}` : '0 0 29 26'}
    aria-hidden="true"
    width={width || '29'}
    height={height || '26'}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      width: !isNil(width) ? `${width}px` : 'inherit',
      height: !isNil(height) ? `${height}px` : 'inherit',
    }}
  >
    <svg width="29" height="26" viewBox="0 0 29 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="0.572754" width="29" height="5" rx="2" fill="white" />
      <rect y="10.5728" width="29" height="5" rx="2" fill="white" />
      <rect y="20.5728" width="22" height="5" rx="2" fill="white" />
    </svg>
  </SvgIcon>
);

IconHamburgerMenu.propTypes = {
  color: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
};

export default IconHamburgerMenu;
